"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var actionRunColumns = [
    { name: "Queued", uid: "created_at" },
    { name: "Segment", uid: "segment_name" },
    { name: "Player", uid: "display_name" },
    { name: "Action", uid: "type" },
    { name: "Stint", uid: "stint" },
    { name: "Status", uid: "status" },
    { name: "Attempts", uid: "attempts" },
    { name: "Last error", uid: "last_error" },
    { name: "Completed", uid: "completed_at" },
    { name: "", uid: "row_actions" },
];
function useColumns(hiddenColumns) {
    var columns = (0, react_1.useMemo)(function () { return actionRunColumns.filter(function (column) { return !hiddenColumns.includes(column.uid); }).map(function (column) { return (__assign(__assign({}, column), { id: column.uid })); }); }, [hiddenColumns]);
    return (0, react_1.useMemo)(function () { return ({ columns: columns, headerColumns: columns }); }, [columns]);
}
